/**
 * Custom Sticky Add to Cart
 * Proxies variant selection and submission through the main product form.
 */

(function() {
  'use strict';

  // More than one featured product section can include this asset on a page.
  if (window.__bikezoneStickyAddToCartLoaded) return;
  window.__bikezoneStickyAddToCartLoaded = true;

  let stickyBar = null;
  let mainProductSection = null;
  let mainAddToCartForm = null;
  let mainAddToCartBtn = null;
  let stickyButton = null;
  let stickyImage = null;
  let stickyError = null;
  let variantData = [];
  let currentVariant = null;
  let observer = null;
  let isEnabled = false;
  let hasScrolledDown = false;
  let pdpOffsetFrame = null;
  let pdpHeaderObserver = null;
  let pdpPanelLastOffset = null;
  let pdpPanelOffsetInitialized = false;
  let pdpPurchaseTrayObserver = null;
  let pdpPurchaseTrayFrame = null;
  let pdpPurchaseTrayLastHeight = null;
  let pdpAvailabilityObserver = null;
  let pdpAvailabilityFrame = null;

  function init() {
    mainProductSection = document.querySelector('.product-section[data-section-type="product"]');
    if (!mainProductSection) {
      return;
    }

    initPdpPurchaseSummary(mainProductSection);
    initPdpPurchaseTrayMeasurement(mainProductSection);
    initPdpPurchasePanelOffset();
    initPdpInstallmentsSync(mainProductSection);
    initBackToOptionsBar(mainProductSection);

    stickyBar = mainProductSection.querySelector('[data-sticky-add-to-cart]');
    if (!stickyBar || stickyBar.dataset.stickyInitialized === 'true') {
      return;
    }

    mainAddToCartForm = mainProductSection.querySelector('.product-single__form');
    mainAddToCartBtn = mainAddToCartForm ? mainAddToCartForm.querySelector('[data-add-to-cart]') : null;
    stickyButton = stickyBar.querySelector('[data-sticky-submit]');
    stickyImage = stickyBar.querySelector('[data-sticky-image]');
    stickyError = stickyBar.querySelector('[data-sticky-error]');

    if (!mainAddToCartForm || !mainAddToCartBtn || !stickyButton) {
      return;
    }

    stickyBar.dataset.stickyInitialized = 'true';
    variantData = getVariantData();
    currentVariant = getInitialVariant();
    hasScrolledDown = window.scrollY > 100;
    isEnabled = true;

    bindEvents();
    setupScrollDetection();
    syncVariantState(currentVariant);
  }

  function initPdpPurchaseSummary(section) {
    const summary = section.querySelector('[data-pdp-sticky-summary]');
    if (!summary) {
      return;
    }

    if (summary.dataset.pdpSummaryInitialized !== 'true') {
      summary.dataset.pdpSummaryInitialized = 'true';

      section.addEventListener('variantChange', function(evt) {
        const detail = evt.detail || {};
        updatePdpPurchaseSummary(summary, detail.variant, detail.currentlySelectedValues);
        setPdpStickyDeliveryChecking(summary);
        scheduleCurrentPdpPurchaseTrayHeight(section);
      });
    }

    initPdpStickyDeliverySync(section, summary);
    syncPdpPurchaseSummaryFromCurrentVariant(section, summary);

    window.requestAnimationFrame(function() {
      syncPdpPurchaseSummaryFromCurrentVariant(section, summary);
    });
  }

  function initPdpInstallmentsSync(section) {
    const installmentVariantInputs = section.querySelectorAll('[data-pdp-installments-product-select]');
    if (!installmentVariantInputs.length || section.dataset.pdpInstallmentsInitialized === 'true') {
      return;
    }

    section.dataset.pdpInstallmentsInitialized = 'true';
    section.addEventListener('variantChange', function(evt) {
      const variant = evt.detail ? evt.detail.variant : null;
      if (!variant) {
        return;
      }

      installmentVariantInputs.forEach(function(input) {
        if (input.value === String(variant.id)) {
          return;
        }

        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function initBackToOptionsBar(section) {
    const bar = section.querySelector('[data-pdp-back-to-options]');
    const target = section.querySelector('[data-pdp-product-options]');
    if (!bar || !target || bar.dataset.backToOptionsInitialized === 'true') {
      return;
    }

    const button = bar.querySelector('[data-pdp-back-to-options-button]');
    const price = bar.querySelector('[data-pdp-back-to-options-price]');
    const purchaseTray = section.querySelector('[data-pdp-add-to-cart-wrapper]');
    const mobileAndTablet = window.matchMedia('(max-width: 1024px)');
    let updateFrame = null;

    if (!button) {
      return;
    }

    bar.dataset.backToOptionsInitialized = 'true';

    function setVisibility(visible) {
      bar.classList.toggle('pdp-back-to-options--visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      button.tabIndex = visible ? 0 : -1;
    }

    function updateVisibility() {
      updateFrame = null;

      if (!mobileAndTablet.matches) {
        setVisibility(false);
        return;
      }

      const optionsRect = target.getBoundingClientRect();
      const hasPassedOptions = optionsRect.bottom < 0;
      let purchaseTrayVisible = false;

      if (purchaseTray) {
        const trayRect = purchaseTray.getBoundingClientRect();
        purchaseTrayVisible = trayRect.bottom > 0 && trayRect.top < window.innerHeight;
      }

      setVisibility(hasPassedOptions && !purchaseTrayVisible);
    }

    function scheduleVisibilityUpdate() {
      if (updateFrame) {
        return;
      }

      updateFrame = window.requestAnimationFrame(updateVisibility);
    }

    button.addEventListener('click', function() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });

      window.setTimeout(function() {
        const firstOption = target.querySelector('[data-variant-input]');
        if (firstOption) {
          firstOption.focus({ preventScroll: true });
        }
      }, reduceMotion ? 0 : 500);
    });

    section.addEventListener('variantChange', function(evt) {
      const variant = evt.detail ? evt.detail.variant : null;
      if (price && variant && typeof variant.price === 'number') {
        price.textContent = formatMoney(variant.price);
      }
    });

    window.addEventListener('scroll', scheduleVisibilityUpdate, { passive: true });
    window.addEventListener('resize', scheduleVisibilityUpdate);

    if (typeof mobileAndTablet.addEventListener === 'function') {
      mobileAndTablet.addEventListener('change', scheduleVisibilityUpdate);
    }

    updateVisibility();
  }

  function initPdpPurchasePanelOffset() {
    if (!document.body.classList.contains('template-product-default-pdp')) {
      return;
    }

    updatePdpPurchasePanelOffset();
    if (pdpPanelOffsetInitialized) {
      return;
    }

    pdpPanelOffsetInitialized = true;
    window.addEventListener('load', schedulePdpPurchasePanelOffset);
    window.addEventListener('resize', schedulePdpPurchasePanelOffset);
    document.addEventListener('shopify:section:load', schedulePdpPurchasePanelOffset);

    const header = document.getElementById('SiteHeader');
    if (header && window.MutationObserver) {
      pdpHeaderObserver = new MutationObserver(schedulePdpPurchasePanelOffset);
      pdpHeaderObserver.observe(header, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }
  }

  function schedulePdpPurchasePanelOffset() {
    if (pdpOffsetFrame) {
      return;
    }

    pdpOffsetFrame = window.requestAnimationFrame(function() {
      updatePdpPurchasePanelOffset();
      pdpOffsetFrame = null;
    });
  }

  function updatePdpPurchasePanelOffset() {
    const header = document.getElementById('SiteHeader');
    const gap = 24;
    const nextOffset = Math.round(getVisiblePdpHeaderHeight(header) + gap);

    if (nextOffset === pdpPanelLastOffset) {
      return;
    }

    pdpPanelLastOffset = nextOffset;
    document.documentElement.style.setProperty('--pdp-dynamic-sticky-offset', `${nextOffset}px`);
  }

  function getVisiblePdpHeaderHeight(header) {
    if (!header) {
      return 0;
    }

    if (
      header.classList.contains('site-header--stuck') &&
      header.classList.contains('site-header--opening')
    ) {
      return header.offsetHeight;
    }

    return 0;
  }

  function initPdpPurchaseTrayMeasurement(section) {
    if (!document.body.classList.contains('template-product-default-pdp')) {
      return;
    }

    const tray = section.querySelector('[data-pdp-add-to-cart-wrapper]');
    if (!tray) {
      return;
    }

    updatePdpPurchaseTrayHeight(tray);

    if (tray.dataset.pdpTrayInitialized === 'true') {
      return;
    }

    tray.dataset.pdpTrayInitialized = 'true';

    if (pdpPurchaseTrayObserver) {
      pdpPurchaseTrayObserver.disconnect();
      pdpPurchaseTrayObserver = null;
    }

    if (window.ResizeObserver) {
      pdpPurchaseTrayObserver = new ResizeObserver(function() {
        schedulePdpPurchaseTrayHeight(tray);
      });
      pdpPurchaseTrayObserver.observe(tray);
    }

    window.addEventListener('load', function() {
      schedulePdpPurchaseTrayHeight(tray);
    }, { once: true });
    window.addEventListener('resize', function() {
      schedulePdpPurchaseTrayHeight(tray);
    });
  }

  function schedulePdpPurchaseTrayHeight(tray) {
    if (pdpPurchaseTrayFrame) {
      return;
    }

    pdpPurchaseTrayFrame = window.requestAnimationFrame(function() {
      updatePdpPurchaseTrayHeight(tray);
      pdpPurchaseTrayFrame = null;
    });
  }

  function updatePdpPurchaseTrayHeight(tray) {
    const nextHeight = Math.ceil(tray.getBoundingClientRect().height);

    if (!nextHeight || nextHeight === pdpPurchaseTrayLastHeight) {
      return;
    }

    pdpPurchaseTrayLastHeight = nextHeight;
    document.documentElement.style.setProperty('--pdp-purchase-tray-height', `${nextHeight}px`);
  }

  function updatePdpPurchaseSummary(summary, variant, selectedValues) {
    const selectedMap = {};

    if (variant) {
      selectedMap.option1 = variant.option1;
      selectedMap.option2 = variant.option2;
      selectedMap.option3 = variant.option3;
    } else if (selectedValues && selectedValues.length) {
      selectedValues.forEach(function(selection) {
        selectedMap[selection.index] = selection.value;
      });
    }

    summary.querySelectorAll('[data-pdp-sticky-option]').forEach(function(option) {
      const value = selectedMap[option.dataset.optionIndex];
      const valueElement = option.querySelector('[data-pdp-sticky-option-value]');
      if (valueElement && value) {
        valueElement.textContent = value;
      }
    });

    if (!variant) {
      return;
    }

    const comparePriceElement = summary.querySelector('[data-pdp-sticky-compare-price]');
    const productPriceElement = summary.querySelector('[data-pdp-sticky-product-price]');
    const onSale = variant.price > 0 && variant.compare_at_price > variant.price;

    if (comparePriceElement) {
      comparePriceElement.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      comparePriceElement.classList.toggle('hide', !onSale);
    }

    if (productPriceElement) {
      productPriceElement.textContent = formatMoney(variant.price);
      productPriceElement.classList.toggle('on-sale', onSale);
    }
  }

  function syncPdpPurchaseSummaryFromCurrentVariant(section, summary) {
    const variant = getCurrentSectionVariant(section);
    if (!variant) {
      return;
    }

    updatePdpPurchaseSummary(summary, variant);
    scheduleCurrentPdpPurchaseTrayHeight(section);
  }

  function getCurrentSectionVariant(section) {
    const variants = getVariantDataFromSection(section);
    if (!variants.length) {
      return null;
    }

    const masterSelect = section.querySelector('[data-product-select]');
    const selectedVariantId = masterSelect ? parseInt(masterSelect.value, 10) : null;
    const selectedVariant = variants.find(function(variant) {
      return variant.id === selectedVariantId;
    }) || null;

    if (selectedVariant && selectedVariant.available && selectedVariant.price > 0) {
      return selectedVariant;
    }

    const currentVariantJson = section.querySelector('[data-current-variant-json]');
    if (currentVariantJson) {
      try {
        const currentVariant = JSON.parse(currentVariantJson.innerHTML);
        const matchingVariant = variants.find(function(variant) {
          return variant.id === currentVariant.id;
        }) || null;

        if (matchingVariant && matchingVariant.available && matchingVariant.price > 0) {
          return matchingVariant;
        }
      } catch (error) {
        // Fall through to the available variant fallback below.
      }
    }

    return getLowestPriceVariantFromList(variants) || getFirstAvailableVariantFromList(variants);
  }

  function getVariantDataFromSection(section) {
    const variantJson = section.querySelector('[data-variant-json]');

    if (!variantJson) {
      return [];
    }

    try {
      return JSON.parse(variantJson.innerHTML);
    } catch (error) {
      return [];
    }
  }

  function getLowestPriceVariantFromList(variants) {
    return variants.reduce(function(lowestPriceVariant, variant) {
      if (!variant.available || variant.price <= 0) {
        return lowestPriceVariant;
      }

      if (!lowestPriceVariant || variant.price < lowestPriceVariant.price) {
        return variant;
      }

      return lowestPriceVariant;
    }, null);
  }

  function getFirstAvailableVariantFromList(variants) {
    return variants.find(function(variant) {
      return variant.available;
    }) || null;
  }

  function initPdpStickyDeliverySync(section, summary) {
    const delivery = summary.querySelector('[data-pdp-sticky-delivery]');
    if (!delivery || delivery.dataset.pdpDeliveryInitialized === 'true') {
      return;
    }

    const availabilityHolder = section.querySelector('bikezone-availability') || section.querySelector('[data-store-availability-holder]');
    if (!availabilityHolder) {
      delivery.classList.add('hide');
      return;
    }

    delivery.dataset.pdpDeliveryInitialized = 'true';
    syncPdpStickyDeliveryFromHolder(summary, availabilityHolder);

    if (window.MutationObserver) {
      if (pdpAvailabilityObserver) {
        pdpAvailabilityObserver.disconnect();
      }

      pdpAvailabilityObserver = new MutationObserver(function() {
        schedulePdpStickyDeliverySync(summary, availabilityHolder, section);
      });

      pdpAvailabilityObserver.observe(availabilityHolder, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  function schedulePdpStickyDeliverySync(summary, availabilityHolder, section) {
    if (pdpAvailabilityFrame) {
      return;
    }

    pdpAvailabilityFrame = window.requestAnimationFrame(function() {
      syncPdpStickyDeliveryFromHolder(summary, availabilityHolder);
      scheduleCurrentPdpPurchaseTrayHeight(section);
      pdpAvailabilityFrame = null;
    });
  }

  function setPdpStickyDeliveryChecking(summary) {
    const delivery = summary.querySelector('[data-pdp-sticky-delivery]');
    if (!delivery) {
      return;
    }

    const heading = delivery.querySelector('[data-pdp-sticky-delivery-heading]');
    const time = delivery.querySelector('[data-pdp-sticky-delivery-time]');
    const link = delivery.querySelector('[data-pdp-sticky-delivery-link]');

    delivery.classList.remove('hide');

    if (heading) {
      heading.textContent = 'Checking pickup availability';
    }

    if (time) {
      time.textContent = '';
      time.classList.add('hide');
    }

    if (link) {
      link.classList.add('hide');
    }
  }

  function syncPdpStickyDeliveryFromHolder(summary, availabilityHolder) {
    const delivery = summary.querySelector('[data-pdp-sticky-delivery]');
    if (!delivery) {
      return;
    }

    const availability = availabilityHolder.querySelector('.store-availability');
    const info = availability ? availability.querySelector('.store-availability__info') : null;

    if (!info) {
      delivery.classList.add('hide');
      return;
    }

    const heading = delivery.querySelector('[data-pdp-sticky-delivery-heading]');
    const time = delivery.querySelector('[data-pdp-sticky-delivery-time]');
    const link = delivery.querySelector('[data-pdp-sticky-delivery-link]');
    const message = Array.prototype.find.call(info.children, function(child) {
      return !child.classList.contains('store-availability__small');
    }) || info.firstElementChild;
    const isFrengee = availabilityHolder.matches('bikezone-availability');
    const pickupTime = isFrengee ? null : info.querySelector('.store-availability__small:not(.store-availability__small--link)');
    const availabilityLink = info.querySelector('.store-availability__small--link a');

    if (!message || !normalizeText(message.textContent)) {
      delivery.classList.add('hide');
      return;
    }

    delivery.classList.remove('hide');

    if (heading) {
      setPdpStickyDeliveryHeading(heading, availability, message);
    }

    if (time) {
      const timeText = pickupTime ? normalizeText(pickupTime.textContent) : '';
      time.textContent = timeText;
      time.classList.toggle('hide', !timeText);
    }

    if (link) {
      if (availabilityLink && normalizeText(availabilityLink.textContent)) {
        link.textContent = 'View store information';
        link.classList.toggle('js-drawer-open-availability', !isFrengee);
        link.onclick = isFrengee ? function(event) {
          event.preventDefault();
          event.stopPropagation();
          availabilityLink.click();
        } : null;
        link.setAttribute('href', availabilityLink.getAttribute('href') || '#StoreAvailabilityDrawer');
        link.setAttribute('aria-controls', availabilityLink.getAttribute('aria-controls') || 'StoreAvailabilityDrawer');
        link.classList.remove('hide');
      } else {
        link.classList.add('hide');
      }
    }
  }

  function normalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function setPdpStickyDeliveryHeading(heading, availability, message) {
    const availableLocation = availability.querySelector('.store-availability__available-location:not(.store-availability__available-location--unavailable)');
    const messageText = normalizeText(message ? message.textContent : '');
    const isInStock = availableLocation || /^In Stock\b/i.test(messageText);

    heading.textContent = '';

    const label = document.createElement('span');
    label.className = 'pdp-sticky-purchase-delivery__status';
    label.textContent = 'Availability:';
    heading.appendChild(label);

    const status = document.createElement('span');
    status.className = 'pdp-sticky-purchase-delivery__location';
    const isFrengee = !!availability.closest('bikezone-availability');
    const statusText = isInStock ? 'In Stock' : isFrengee
      ? (/^Transfer available\b/i.test(messageText) ? 'Available for transfer'
        : /^Currently out of stock$/i.test(messageText) ? 'Out of Stock' : messageText)
      : 'Out of Stock';
    status.textContent = ' ' + statusText;
    heading.appendChild(status);
  }

  function scheduleCurrentPdpPurchaseTrayHeight(section) {
    const tray = section ? section.querySelector('[data-pdp-add-to-cart-wrapper]') : null;
    if (tray) {
      schedulePdpPurchaseTrayHeight(tray);
    }
  }

  function bindEvents() {
    window.addEventListener('scroll', handleScroll, { passive: true });
    mainProductSection.addEventListener('variantChange', handleVariantChange);
    mainAddToCartForm.addEventListener('submit', handleMainFormSubmit);
    mainAddToCartForm.addEventListener('ajaxProduct:added', handleMainFormSuccess);
    mainAddToCartForm.addEventListener('ajaxProduct:error', handleMainFormError);

    stickyBar.querySelectorAll('[data-sticky-option-select]').forEach(function(select) {
      select.addEventListener('change', handleStickyOptionChange);
    });

    stickyButton.addEventListener('click', handleStickySubmit);
  }

  function handleScroll() {
    if (window.scrollY > 100) {
      hasScrolledDown = true;
    }

    if (window.scrollY <= 50) {
      hideStickyBar();
    }
  }

  function setupScrollDetection() {
    hideStickyBar();

    if (observer) {
      observer.disconnect();
    }

    observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          showStickyBar();
        } else {
          hideStickyBar();
        }
      });
    }, {
      rootMargin: '0px 0px -45% 0px',
      threshold: 0
    });

    observer.observe(mainAddToCartBtn);
  }

  function handleStickyOptionChange(evt) {
    clearError();

    const select = evt.currentTarget;
    const optionIndex = select.dataset.optionIndex;
    const selectedValue = select.value;
    const mainGroup = mainProductSection.querySelector('.variant-input-wrap[data-index="' + optionIndex + '"]');

    if (!mainGroup) {
      return;
    }

    const mainSelect = mainGroup.querySelector('select[data-variant-input]');
    if (mainSelect) {
      if (mainSelect.value !== selectedValue) {
        mainSelect.value = selectedValue;
        mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    const mainInput = Array.prototype.find.call(
      mainGroup.querySelectorAll('input[data-variant-input]'),
      function(input) {
        return input.value === selectedValue;
      }
    );

    if (!mainInput) {
      return;
    }

    if (!mainInput.checked) {
      mainInput.checked = true;
    }

    mainInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function handleStickySubmit(evt) {
    evt.preventDefault();

    if (!mainAddToCartForm || !stickyButton || stickyButton.disabled) {
      return;
    }

    clearError();
    showLoadingState();

    if (typeof mainAddToCartForm.requestSubmit === 'function') {
      try {
        mainAddToCartForm.requestSubmit();
        return;
      } catch (error) {
        // Fall through to click-based submission for older browsers.
      }
    }

    mainAddToCartBtn.click();
  }

  function handleMainFormSubmit() {
    clearError();
    showLoadingState();
  }

  function handleMainFormSuccess() {
    stopLoadingState();
    clearError();
    syncVariantState(currentVariant);
  }

  function handleMainFormError(evt) {
    stopLoadingState();
    syncVariantState(currentVariant);

    if (stickyError && evt.detail && evt.detail.errorMessage) {
      stickyError.textContent = evt.detail.errorMessage;
      stickyError.classList.remove('hide');
    }
  }

  function handleVariantChange(evt) {
    currentVariant = evt.detail ? evt.detail.variant : null;
    syncVariantState(currentVariant, evt.detail ? evt.detail.currentlySelectedValues : null);
  }

  function syncVariantState(variant, selectedValues) {
    syncButtonPresentation(variant);
    syncPrice(variant);
    syncImage(variant);
    syncSelections(variant, selectedValues);
    syncOptionAvailability();
  }

  function syncButtonPresentation(variant) {
    if (!stickyButton) {
      return;
    }

    stickyButton.classList.toggle('btn--secondary', mainAddToCartBtn.classList.contains('btn--secondary'));

    const buttonText = stickyBar.querySelector('[data-sticky-button-text]');
    const defaultText = stickyButton.dataset.defaultText || 'Add to cart';

    if (!variant) {
      stickyButton.disabled = true;
      stickyButton.classList.add('disabled');
      if (buttonText) {
        buttonText.textContent = window.theme && theme.strings ? theme.strings.unavailable : 'Unavailable';
      }
      return;
    }

    const variantCanPurchase = variant.available && variant.price > 0;

    stickyButton.disabled = !variantCanPurchase;
    stickyButton.classList.toggle('disabled', !variantCanPurchase);

    if (buttonText) {
      buttonText.textContent = variantCanPurchase
        ? defaultText
        : (window.theme && theme.strings ? (variant.available ? theme.strings.unavailable : theme.strings.soldOut) : (variant.available ? 'Unavailable' : 'Sold out'));
    }
  }

  function syncPrice(variant) {
    if (!stickyBar) {
      return;
    }

    const priceWrapper = stickyBar.querySelector('[data-sticky-price-wrap]');
    const comparePriceElement = stickyBar.querySelector('[data-sticky-compare-price]');
    const productPriceElement = stickyBar.querySelector('[data-sticky-product-price]');

    if (!productPriceElement) {
      return;
    }

    if (!variant) {
      const mainPriceElement = mainProductSection.querySelector('[data-product-price]');
      if (mainPriceElement) {
        productPriceElement.innerHTML = mainPriceElement.innerHTML;
      }
      if (priceWrapper && comparePriceElement) {
        const mainComparePrice = mainProductSection.querySelector('[data-compare-price]');
        comparePriceElement.innerHTML = mainComparePrice ? mainComparePrice.innerHTML : '';
        priceWrapper.classList.toggle('hide', !comparePriceElement.textContent.trim());
      }
      return;
    }

    const onSale = variant.price > 0 && variant.compare_at_price > variant.price;

    productPriceElement.innerHTML = formatMoney(variant.price);
    productPriceElement.classList.toggle('on-sale', onSale);

    if (priceWrapper && comparePriceElement) {
      if (onSale) {
        comparePriceElement.innerHTML = formatMoney(variant.compare_at_price);
        priceWrapper.classList.remove('hide');
      } else {
        comparePriceElement.innerHTML = '';
        priceWrapper.classList.add('hide');
      }
    }
  }

  function syncImage(variant) {
    if (!stickyImage) {
      return;
    }

    const fallbackImage = stickyBar.dataset.defaultImage;
    const nextImage = variant && variant.featured_image && variant.featured_image.src
      ? variant.featured_image.src
      : fallbackImage;

    if (nextImage) {
      stickyImage.src = nextImage;
    }
  }

  function syncSelections(variant, selectedValues) {
    const stickySelects = stickyBar.querySelectorAll('[data-sticky-option-select]');
    if (!stickySelects.length) {
      return;
    }

    const selectedMap = {};

    if (variant) {
      stickySelects.forEach(function(select) {
        selectedMap[select.dataset.optionIndex] = variant[select.dataset.optionIndex];
      });
    } else if (selectedValues && selectedValues.length) {
      selectedValues.forEach(function(selection) {
        selectedMap[selection.index] = selection.value;
      });
    }

    stickySelects.forEach(function(select) {
      const nextValue = selectedMap[select.dataset.optionIndex];
      if (nextValue && select.value !== nextValue) {
        select.value = nextValue;
      }
    });
  }

  function syncOptionAvailability() {
    stickyBar.querySelectorAll('[data-sticky-option-select]').forEach(function(stickySelect) {
      const optionIndex = stickySelect.dataset.optionIndex;
      const mainGroup = mainProductSection.querySelector('.variant-input-wrap[data-index="' + optionIndex + '"]');

      if (!mainGroup) {
        return;
      }

      const mainSelect = mainGroup.querySelector('select[data-variant-input]');
      const stickyOptions = stickySelect.querySelectorAll('option');

      stickyOptions.forEach(function(option) {
        if (!option.dataset.baseLabel) {
          option.dataset.baseLabel = option.textContent.replace(' - Unavailable', '');
        }

        if (mainSelect) {
          const mainOption = Array.prototype.find.call(mainSelect.options, function(item) {
            return item.value === option.value;
          });

          const unavailable = mainOption ? mainOption.disabled : true;
          option.disabled = unavailable;
          option.hidden = unavailable;
          option.style.display = unavailable ? 'none' : '';
          option.textContent = option.dataset.baseLabel;
          return;
        }

        const mainInput = Array.prototype.find.call(
          mainGroup.querySelectorAll('input[data-variant-input]'),
          function(input) {
            return input.value === option.value;
          }
        );

        const unavailable = mainInput ? mainInput.classList.contains('disabled') : true;
        option.disabled = unavailable;
        option.hidden = unavailable;
        option.style.display = unavailable ? 'none' : '';
        option.textContent = option.dataset.baseLabel;
      });
    });
  }

  function getVariantData() {
    const variantJson = mainProductSection.querySelector('[data-variant-json]');

    if (!variantJson) {
      return [];
    }

    try {
      return JSON.parse(variantJson.innerHTML);
    } catch (error) {
      return [];
    }
  }

  function getInitialVariant() {
    const masterSelect = mainAddToCartForm.querySelector('[data-product-select]');
    if (!masterSelect || !variantData.length) {
      return null;
    }

    const selectedVariantId = parseInt(masterSelect.value, 10);

    return variantData.find(function(variant) {
      return variant.id === selectedVariantId;
    }) || null;
  }

  function showStickyBar() {
    if (!stickyBar || !isEnabled) {
      return;
    }

    if (!hasScrolledDown || window.scrollY <= 50) {
      return;
    }

    stickyBar.classList.remove('sticky-add-to-cart--hidden');
    stickyBar.classList.add('sticky-add-to-cart--visible');
  }

  function hideStickyBar() {
    if (!stickyBar) {
      return;
    }

    stickyBar.classList.remove('sticky-add-to-cart--visible');
    stickyBar.classList.add('sticky-add-to-cart--hidden');
  }

  function showLoadingState() {
    if (!stickyButton) {
      return;
    }

    stickyButton.classList.add('btn--loading');
    stickyButton.disabled = true;
  }

  function stopLoadingState() {
    if (!stickyButton) {
      return;
    }

    stickyButton.classList.remove('btn--loading');
  }

  function clearError() {
    if (!stickyError) {
      return;
    }

    stickyError.textContent = '';
    stickyError.classList.add('hide');
  }

  function formatMoney(cents) {
    if (typeof window.theme !== 'undefined' && window.theme.Currency) {
      return window.theme.Currency.formatMoney(cents, window.theme.settings && window.theme.settings.moneyFormat
        ? window.theme.settings.moneyFormat
        : '{{amount}}');
    }

    return '$' + (cents / 100).toFixed(2);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }

  document.addEventListener('shopify:section:load', function() {
    init();
  });
})();
